import { lazy } from "react";
import { RouterItemType } from "@/app/module/router/index";

const LayoutPageSubscriptions = lazy(() => import("./layout/index"));

export const routerPageSubscriptions: RouterItemType = {
  path: "/subscriptions",
  authorize: true,
  element: <LayoutPageSubscriptions />,
};
